import {
  legacy_createStore as createStore,
  combineReducers,
  compose,
  applyMiddleware,
} from 'redux';
import { createLogger } from 'redux-logger';
import userReducer from './reducers/user';
import authReducer from './reducers/auth';
import formReducer from './reducers/form';
import eventReducer from './reducers/eventReducer';
import socketConnectionReducer from './reducers/socketConnectionReducer';
import chatScreenReducer from './reducers/chatScreenReducer';
import loaderReducer from './reducers/loaderReducer';
import toastReducer from './reducers/toastReducer';
import audioRedux from './reducers/audio';

const rootReducer = combineReducers({
  user: userReducer,
  auth: authReducer,
  form: formReducer,
  events: eventReducer,
  socketConnection: socketConnectionReducer,
  chatScreen: chatScreenReducer,
  loader: loaderReducer,
  toast: toastReducer,
  audio: audioRedux
});

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Create logger middleware with proper typing
const logger = createLogger({
  collapsed: true,
  diff: true,
  duration: true,
  timestamp: true,
}) as any; // Type assertion to fix TypeScript compatibility

// Create store with logger middleware
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(logger))
);

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
export default store;
